import * as style from '../../utils/general_style.js';

function CarteFrance() {
	return (
        <div style={style.ROW_CENTER}>
            <iframe src='https://taba.dev/cartes/tabacarte.html' title="Carte de France interactive des lieues d'investigations" style={{border: `1px solid ${style.COLORS.grey}`, width: '702px', height: '702px', boxShadow: '0px 2px 10px 2px rgba(0, 0, 0, 0.25)'}}></iframe>
        </div>
	);
};

export default CarteFrance;